/* eslint-disable new-cap */
import {defineCustomElement} from 'extensions/utils';
import {LitElement, html} from 'lit';
import styles from './my-registry.component.scss?as=stylesheet';

class MyRegistry extends LitElement {
	static get styles () {
		return [styles];
	}

	static get properties () {
		return {
			developmentMode: {
				attribute: 'development-mode',
				type: Boolean
			},
			imageURL: {
				attribute: 'image-url',
				type: String
			},
			price: {
				type: Number
			},
			quantity: {
				type: Number
			},
			siteKey: {
				attribute: 'site-key',
				type: String
			},
			sku: {
				type: String
			},
			title: {
				type: String
			},
			url: {
				type: String
			}
		};
	}

	connectedCallback () {
		super.connectedCallback();

		this.loadSDK();
	}

	constructor () {
		super();

		this.developmentMode = false;
		this.imageURL = '';
		this.price = 0.00;
		this.quantity = 0;
		this.siteKey = '';
		this.sku = '';
		this.title = '';
		this.url = '';
	}

	render () {
		return html`<slot @click="${this.handleClick}"></slot>`;
	}

	loadSDK () {
		if (typeof window.MyRegistrySDK !== 'undefined') {
			return;
		}

		// Load in the SDK
		const scriptElement = document.createElement('script');
		scriptElement.src = `//www.${this.developmentMode ? 'mrtesting' : 'myregistry'}.com/ScriptPlatform/API/AddButtonSDK.js?siteKey=${this.siteKey}`;

		document.head?.appendChild(scriptElement);
	}

	handleClick () {
		const myregistrysdk = new window.MyRegistrySDK({
			HideColor: true,
			HideSize: true,
			ImageUrl: this.imageURL,
			Price: this.price,
			Quantity: this.quantity,
			SKU: this.sku,
			Title: this.title,
			URL: this.url
		});

		myregistrysdk?.showPopup?.();
	}

}

defineCustomElement('x-my-registry', MyRegistry);
